export default "__VITE_ASSET__DvAGRt50__"